module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"view":"View","add_to_collection":"Add to Collection ...","login_message":"Login to view image","share_article":"Share ..."}}')
  delete Component.options._Ctor
}
